import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'



export const processaValoresDefaultIniciaisConfiguracaoGestaoPatrimonial = ( values ) => {
    
    if (!values.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos) {

        values.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos = false
    }

    if (!values.exibirCapitalSeguradoCarteiraInvestimentos) {

        values.exibirCapitalSeguradoCarteiraInvestimentos = false
    }

    //if (!values.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos && !values.exibirCapitalSeguradoCarteiraInvestimentos) {

    //    values.exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos = false
    //}

    //if (!values.exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos) {

    //    values.exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos = false
    //}

    if (!values.premioVidaInteiraOriundoCarteiraInvestimentos) {

        values.premioVidaInteiraOriundoCarteiraInvestimentos = false
        values.idRecursoFinanceiroOrigemOrigemPremioVidaInteira = ''
    }

    if (!existeTabelaEvolucaoValorResgate(values, HARDCODE.idFamiliarCliente)) {

        values.idadeSimularResgateVidaInteiraCliente = ''
    }

    if (!existeTabelaEvolucaoValorResgate(values, HARDCODE.idFamiliarConjuge)) {

        values.idadeSimularResgateVidaInteiraConjuge = ''
    }
    
    if (!values.aplicarTaxaInflacaoSimulacaoResgateVidaInteira) {

        values.aplicarTaxaInflacaoSimulacaoResgateVidaInteira = false
    }

    if (!values.aplicarTaxaInflacaoCarteiraInvestimentos) {

        values.aplicarTaxaInflacaoCarteiraInvestimentos = false
    }
    
    if (!values.exibirResumoSeguroVidaCotacao) {

        values.exibirResumoSeguroVidaCotacao = false
    }
    
    if (!values.exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado) {

        values.exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado = false
    }

    if (!values.exibirValorResgateSomenteAPartirQuitacaoSeguroVidaInteira) {

        values.exibirValorResgateSomenteAPartirQuitacaoSeguroVidaInteira = false
    }

    //if (!values.exibirEconomiaInventarioSeguroVidaTabelaEvolucaoValorResgate) {

    //    values.exibirEconomiaInventarioSeguroVidaTabelaEvolucaoValorResgate = false
    //}

    if (!values.aplicarTaxaInflacaoTabelaEvolucaoValorResgate) {

        values.aplicarTaxaInflacaoTabelaEvolucaoValorResgate = false
        values.calcularPremioAnualizadoAcumuladoSomaSimples = false
        values.exibirTambemTabelaEvolucaoValorResgateSemTaxaInflacao = false
    }

    if (!values.calcularPremioAnualizadoAcumuladoSomaSimples) {

        values.calcularPremioAnualizadoAcumuladoSomaSimples = false
    }
    
    if (!values.exibirTambemTabelaEvolucaoValorResgateSemTaxaInflacao) {

        values.exibirTambemTabelaEvolucaoValorResgateSemTaxaInflacao = false
    }

    if (!values.limitarQtdeAnosExibidosGraficosTabelasEvolucao) {

        values.limitarQtdeAnosExibidosGraficosTabelasEvolucao = false
        values.anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao = ''
    }
    
    if (!values.exibirTabelaEvolucaoCS) {

        values.exibirTabelaEvolucaoCS = false
    }
    
    if (!values.exibirTabelaEvolucaoCancelamentoApolice) {

        values.exibirTabelaEvolucaoCancelamentoApolice = false
    }
    
    if (!values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira) {

        values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira = false
    }

    if (!values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarDespesasAdvocaticiasCustasJudiciais) {

        values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarDespesasAdvocaticiasCustasJudiciais = false
    }

    if (!values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarItcmd) {

        values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarItcmd = false
    }

     if (!values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira) {

        values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira = false
    }

    if (!values.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia) {

        values.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia = false
    }

    if (!values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia) {

        values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia = false
    }
}